
import { apiSlice } from './apiSlice';
const USERS_URL = `${process.env.REACT_APP_BACKEND_URI}/api/v1`;
// const USERS_URL = process.env.REACT_APP_BACKEND_URI;


export const strategyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    CreateStrategy: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/strategy/create-strategy`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    getAllStrategy: builder.query({
  query: () => ({
    url: `${USERS_URL}/strategy/get-strategy`,
    method: 'GET',
    credentials: "include",
  }),
}),
// strategyApiSlice.js

assignStrategyMetrics: builder.query({
  query: (strategyId) => ({
    url: `${USERS_URL}/strategy/strategy-metrics/${strategyId}`,
    method: "GET",
        credentials: "include",

  }),
}),
assignStrategy: builder.mutation({
  query: (data) => ({
    url: `${USERS_URL}/strategy/assign-strategy`,
    method: "POST",
    body: data,
    credentials: "include",
  }),
}),

deleteStrategy: builder.mutation({
  query: (data) => ({
    url: `${USERS_URL}/strategy/delete-strategies`,
    method: "DELETE",
    body: data,
    credentials: "include",
  }),
}),

   getStrategyMetrics: builder.query({
      query: (strategyId) => ({
        url: `${USERS_URL}/strategy/strategy-metrics/${strategyId}`,
        method: "GET",
            credentials: "include",

      }),
    }),
    getInsight: builder.query({
      query: (strategyId) => ({
        url: `${USERS_URL}/strategy/getInsight/${strategyId}`,
        method: "GET",
            credentials: "include",

      }),
    }),
})})
export const {useCreateStrategyMutation,useGetAllStrategyQuery,useDeleteStrategyMutation,useAssignStrategyMetricsQuery,useGetInsightQuery,useGetStrategyMetricsQuery,useAssignStrategyMutation}=strategyApiSlice;


